module.exports = __webpack_public_path__ + "img/premium-img-4.9d4bd25a.png";